/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import events from "dom/events";
import rothko from "modules/rothko";

const FADED_MODIFIER = "sale-hub-filter-tool--faded";
const STEP_SECTION_SELECTOR = ".sale-hub-filter-tool__step-section";
const FILTER_BUTTONS_SELECTOR = ".sale-hub-filter-tool__filter-button";
const TEXT_TO_FILL_SELECTOR = ".sale-hub-filter-tool__fill-in-text";
const START_OVER_SELECTOR = ".sale-hub-filter-tool__start-over";
const SEARCH_INPUT_SELECTOR = ".sale-hub-filter-tool__search-input";

export default baustein.register("sale-hub-filter-tool", {
    defaultOptions: {
        gender: ""
    },

    setupEvents(add) {
        add("click", FILTER_BUTTONS_SELECTOR, this.onFilterButtonClick);
        add("click", START_OVER_SELECTOR, this.startOver);
        add("focus", SEARCH_INPUT_SELECTOR, this.onSearchInputFocus);
        add("keyup", SEARCH_INPUT_SELECTOR, this.onSearchInputKeyUp);
    },

    init() {
        this.step = 0;
        this.promoQuery = {};
        this.transitioning = false;
        this.designersToSearch = [];
    },

    onFilterButtonClick(event) {
        if (this.transitioning) {
            return;
        }

        this.transitioning = true;

        const { context, value } = event.target.dataset;
        const text = event.target.textContent.replace(/  /g, "").trim();

        this.fillTextByContext(context, text);
        this.promoQuery[context] = [value];

        if (context === "product_type") {
            this.showDesignersForType(value);
        }

        this.step++;
        this.transitionToCurrentStep();
    },

    transitionToCurrentStep() {
        events
            .onTransitionEnd(this.el, () => {
                this.el.classList.add(FADED_MODIFIER);
            })
            .then(
                () => {
                    const stepElements = this.el.querySelectorAll(STEP_SECTION_SELECTOR);
                    Array.from(stepElements).forEach(el => {
                        if (el.dataset.step == this.step) {
                            el.classList.remove("hidden");
                        } else {
                            el.classList.add("hidden");
                        }
                    });

                    this.el.classList.remove(FADED_MODIFIER);
                    this.transitioning = false;

                    this.emit("onPromotionQueryComplete", this.promoQuery);
                },
                300,
                "opacity"
            );
    },

    showDesignersForType(productType) {
        const designersLists = this.el.querySelectorAll(".sale-hub-filter-tool__designers-list");
        Array.from(designersLists).forEach(el => {
            if (el.dataset.productType === productType) {
                el.classList.remove("hidden");
            } else {
                el.classList.add("hidden");
            }
        });
        const placeHolderText = this.el.querySelector(
            ".sale-hub-filter-tool__designers-placeholder-text"
        );
        placeHolderText.classList.remove("hidden");
    },

    hideAllDesignersForType() {
        const designersLists = this.el.querySelectorAll(".sale-hub-filter-tool__designers-list");
        const placeHolderText = this.el.querySelector(
            ".sale-hub-filter-tool__designers-placeholder-text"
        );
        Array.from(designersLists).forEach(el => el.classList.add("hidden"));
        placeHolderText.classList.add("hidden");
    },

    fillTextByContext(context, text) {
        const textToFill = this.el.querySelectorAll(
            `${TEXT_TO_FILL_SELECTOR}[data-context="${context}"]`
        );
        Array.from(textToFill).forEach(el => (el.textContent = text));
    },

    emptyAllText() {
        const textToEmpty = this.el.querySelectorAll(TEXT_TO_FILL_SELECTOR);
        Array.from(textToEmpty).forEach(el => (el.textContent = ""));
    },

    startOver() {
        this.promoQuery = {};
        this.step = 0;
        this.transitionToCurrentStep();
        this.hideDesignerSearchResults();
        this.el.querySelector(SEARCH_INPUT_SELECTOR).value = "";

        this.emit("onResetFilterTool");
    },

    onSearchInputFocus() {
        // we only want to do this once.
        if (this.designersToSearch.length) {
            return;
        }

        rothko.fetch("modules/sale_hub_filter_tool", { gender: this.options.gender }).then(data => {
            this.designersToSearch = data.designers;
        });
    },

    onSearchInputKeyUp(event) {
        const searchTerm = event.target.value.toLowerCase();

        if (searchTerm === "") {
            this.hideDesignerSearchResults();
            this.showDesignersForType(this.promoQuery["product_type"][0]);
            return;
        }

        const filteredDesigners = this._getFilteredDesignersFromSearchTerm(searchTerm);

        this.showDesignerSearchResults(filteredDesigners);
    },

    showDesignerSearchResults(filteredDesigners) {
        const formattedDesigners = filteredDesigners.map(designer => {
            return {
                slug: designer.path.replace(/\//g, "").trim(),
                name: designer.name
            };
        });

        this.hideAllDesignersForType();

        const searchResultsComponent = this.findComponent("sale-hub-filter-tool-search-results");
        searchResultsComponent.setRenderContext({
            sale_hub_filter_tool_search_results: {
                designers: formattedDesigners.slice(0, 6)
            }
        });
        searchResultsComponent.show();
    },

    hideDesignerSearchResults() {
        this.findComponent("sale-hub-filter-tool-search-results").hide();
    },

    _getFilteredDesignersFromSearchTerm(searchTerm) {
        const filteredDesigners = this.designersToSearch.filter(designer => {
            return designer.name.toLowerCase().includes(searchTerm);
        });

        return filteredDesigners;
    }
});

